import React from "react";
import IOrder_Progress_State from "../../../../models/IOrder_Progress_State";
import OrderStatesEnum from "../../../../models/OrderStatesEnum";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import { isFulfillmentStep } from "./workflowSteps";

type Props = {
    steps: IOrder_Progress_State[];
    /** The highlighted step, if any. */
    currentId?: OrderStatesEnum | null;
    /** When given, the pills are buttons that select a step. */
    onPick?: (id: OrderStatesEnum) => void;
    small?: boolean;
};

/** The workflow as a row of pills, the way the order screen shows progress. */
export const WorkflowTracker = (props: Props) => {
    return (
        <div className={"WorkflowTracker" + (props.small ? " small" : "")} data-testid={"workflow-tracker"}>
            {props.steps.map((step, index) => {
                const className = [
                    "WorkflowTracker-step",
                    step.order_state_id === props.currentId ? "current" : "",
                    isFulfillmentStep(step) ? "locked" : "",
                    step.isFinalStep ? "final" : "",
                ]
                    .filter(Boolean)
                    .join(" ");

                const content = (
                    <>
                        {step.isFinalStep ? <i className={"fad fa-flag-checkered"} aria-hidden={true} /> : null}
                        <OwLabel title={step.name} noBottomMargin={true} />
                    </>
                );

                return (
                    <React.Fragment key={step.order_state_id}>
                        {index > 0 ? <span className={"WorkflowTracker-line"} aria-hidden={true} /> : null}
                        {props.onPick ? (
                            <button type={"button"} className={className} onClick={() => props.onPick!(step.order_state_id)}>
                                {content}
                            </button>
                        ) : (
                            <span className={className}>{content}</span>
                        )}
                    </React.Fragment>
                );
            })}
        </div>
    );
};

export default WorkflowTracker;
